<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Remove Something</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              v-html="'Are you sure to remove <strong>' + object_identifier + '</strong>'"
            ></v-flex>
            <v-flex>
              <v-alert :value="true" type="error" v-if="error">{{error}}</v-alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn flat @click="dialog = false">
          <v-icon>close</v-icon>Close
        </v-btn>
        <v-spacer />
        <v-btn flat @click="doRemove">
          <v-icon>delete</v-icon>Remove
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    doRemove() {
      this.error = null;
      this.$store
        .dispatch(this.action, this.object)
        .then(() => {
          this.dialog = false;
        })
        .catch(e => {
          console.log(e.response.data);
          this.error = e.response.data.message || e;
        });
    }
  },
  props: {
    object_identifier: String,
    object: Object,
    action: String
  },

  data() {
    return {
      dialog: false,
      error: null
    };
  }
};
</script>
